
import {useEffect, useRef, useLayoutEffect, useState} from "react";
const SingleOTPInputComponent = (props) => {
    function usePrevious(value) {
        const ref = useRef();
      
        // Store current value in ref
        useEffect(() => {
          ref.current = value;
        }, [value]); // Only re-run if value changes
      
        // Return previous value (happens before update in useEffect above)
        return ref.current;
      }
    const { focus, autoFocus, ...rest } = props;
    const inputRef = useRef(null);
    const prevFocus = usePrevious(!!focus);
    useLayoutEffect(() => {
      if (inputRef.current) {
        if (focus && autoFocus) {
          inputRef.current.focus();
        }
        if (focus && autoFocus && focus !== prevFocus) {
          inputRef.current.focus();
          inputRef.current.select();
        }
      }
    }, [autoFocus, focus, prevFocus]);
  
    return <input ref={inputRef} {...rest} />;
  }
  
  export default SingleOTPInputComponent;